import loadable from '@loadable/component';
import React from 'react';

import Spin from '../../spin/spin';

export const RobotBlocklyLoadable = loadable(() => import(/* webpackChunkName: "robot-blockly" */ './robot__blockly'), {
    fallback: <Spin center delay />,
});
